<ul class="vertical-menu" nz-menu [nzMode]="'inline'" style="border: none; width: 100%; padding-top: 50px;">
    <!-- <p class="group-title">Quote Requests</p>
    <li nz-menu-item [nzSelected]="typeFilter === 'sent-quote-request'" (click)="changeTypeFilter.emit('sent-quote-request')">Sent</li>
    <li nz-menu-item [nzSelected]="typeFilter === 'received-quote-request'" (click)="changeTypeFilter.emit('received-quote-request')">Received</li> -->

    <p class="group-title">Messages</p>
    <!-- <li nz-menu-item [nzSelected]="typeFilter === undefined" (click)="changeTypeFilter.emit(undefined)">All Messages</li> -->
    <li nz-menu-item [nzSelected]="typeFilter === 'dm'" (click)="changeTypeFilter.emit('dm')">Direct Messages</li>
  </ul>